<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="M2 11.5c0 1.746 1.504 3.167 3.353 3.167a3.44 3.44 0 0 0 2.29-.866l6.696 3.614c-.02.138-.045.275-.045.418C14.294 19.58 15.8 21 17.647 21 19.496 21 21 19.58 21 17.833c0-1.746-1.504-3.166-3.353-3.166a3.44 3.44 0 0 0-2.29.865L8.661 11.92c.02-.138.045-.275.045-.419 0-.144-.025-.28-.045-.42l6.696-3.612a3.44 3.44 0 0 0 2.29.865c1.849 0 3.353-1.42 3.353-3.166S19.496 2 17.647 2c-1.848 0-3.353 1.42-3.353 3.167 0 .143.025.28.045.419L7.643 9.199a3.44 3.44 0 0 0-2.29-.866C3.504 8.333 2 9.754 2 11.5Z"
  />
</svg>
